export default __webpack_public_path__ + "static/share-4d0f77a35358d31b780e92958123f8cc.jpg";